export default function Skeleton() {
    return (
        <div className="space-y-3" aria-hidden="true" data-testid="job-list-skeleton">
            {[0, 1].map((i) => (
                <div
                    key={i}
                    className="animate-pulse rounded-xl border border-gray-200 p-4 dark:border-gray-800"
                >
                    <div className="h-4 w-2/3 rounded bg-gray-200 dark:bg-gray-700" />
                    <div className="mt-3 h-2.5 w-full rounded-full bg-gray-200 dark:bg-gray-700" />
                    <div className="mt-3 h-3 w-1/3 rounded bg-gray-200 dark:bg-gray-700" />
                </div>
            ))}
        </div>
    );
}
